import type { PageFooterData } from '#/components/PageFooter/types/PageFooterData';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetInternshipsRoutePath } from '#/modules/search/internships/routing/searchGetInternshipsRoutePath';
import { searchGetJobsRoutePath } from '#/modules/search/jobs/routing/searchGetJobsRoutePath';
import { searchGetOrgsRoutePath } from '#/modules/search/orgs/routing/searchGetOrgsRoutePath';
import { searchGetVolopsRoutePath } from '#/modules/search/volops/routing/searchGetVolopsRoutePath';
import { SIGN_UP_TO_POST_URL_FOR_LOCALE } from '#/routing/route-constants';

export const pageFooterDataEn: PageFooterData = {
  idealistDays: null,
  volunteer: {
    title: 'Volunteer',
    links: [
      {
        type: 'volunteer',
        title: 'Volunteer Opportunities',
        href: searchGetVolopsRoutePath({
          locale: I18nLocale.EN,
          embedSearchWidgetId: null,
        }),
      },
      {
        type: 'done-in-a-day',
        title: 'Done in a Day Opportunities',
        href: searchGetVolopsRoutePath({
          locale: I18nLocale.EN,
          filtersByName: { canBeDoneInADay: true },
          embedSearchWidgetId: null,
        }),
      },
      {
        type: 'organizations',
        title: 'Organizations',
        href: searchGetOrgsRoutePath({ locale: I18nLocale.EN }),
      },
      {
        type: 'volunteer-resources',
        title: 'Volunteer Resources',
        href: '/en/volunteering-resources?pq=',
      },
      {
        type: 'idealist-days',
        title: 'Idealist Days',
        href: '/en/days/get-involved',
      },
    ],
  },
  findAJob: {
    title: 'Find a Job',
    links: [
      {
        type: 'jobs',
        title: 'Jobs',
        href: searchGetJobsRoutePath({
          locale: I18nLocale.EN,
          embedSearchWidgetId: null,
        }),
      },
      {
        type: 'internships',
        title: 'Internships',
        href: searchGetInternshipsRoutePath({ locale: I18nLocale.EN }),
      },
      {
        type: 'organizations',
        title: 'Organizations',
        href: searchGetOrgsRoutePath({ locale: I18nLocale.EN }),
      },
      {
        type: 'salary-explorer',
        title: 'Salary Explorer',
        href: '/nonprofit-salary-explorer',
      },
      {
        type: 'career-advice',
        title: 'Career Advice',
        href: '/en/careers',
      },
    ],
  },
  postOnIdealist: {
    title: 'Post on Idealist',
    links: [
      {
        type: 'post-a-job-listing',
        title: 'Post a Job Listing',
        href: '/organization',
      },
      {
        type: 'post-a-volunteer-listing',
        title: 'Post a Volunteer Opportunity',
        href: '/en/orgs/post-free-volunteer-listings',
      },
      {
        type: 'create-org',
        title: 'Add your Organization',
        href: SIGN_UP_TO_POST_URL_FOR_LOCALE.en,
      },
      {
        type: 'volunteer-engagement-resources',
        title: 'Volunteer Engagement Resources',
        href: '/en/orgs/volunteer-engagement-resources',
      },
      {
        type: 'recruit-graduate-students',
        title: 'Recruit Graduate Students',
        href: '/grad-schools/exhibit',
      },
    ],
  },
  aboutUs: {
    title: 'About Us',
    links: [
      {
        type: 'our-story',
        title: 'Our Story',
        href: '/en/about',
      },
      {
        type: 'our-team',
        title: 'Our Team',
        href: '/en/about/our-team',
      },
      {
        type: 'data-insights',
        title: 'Data & Insights',
        href: '/en/insights',
      },
      {
        type: 'help-center',
        title: 'Help Desk',
        href: '/en/help',
      },
      {
        type: 'donate',
        title: 'Donate to Idealist',
        href: 'https://giving.classy.org/campaign/673245/donate',
      },
    ],
  },
  contactUs: null,
  missionStatement:
    'Connecting more than 200,000 organizations with millions of people looking for social-impact jobs and volunteer opportunities.',
};
